import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnalisesSpggProjeto } from '../models/analises-spgg-projeto.model';

@Injectable({
  providedIn: 'root'
})
export class AnalisesSpggProjetoService  extends BaseService<AnalisesSpggProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/analises-spgg';
  }

  public getOptions(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/getOptions/${id}`, { headers: this.headers });
  }
}
